<div class="header-container">
  <div class="my-2 header-title">
    <rtl2-logo class="mx-2" size="35" [color]="'#ffffff'"></rtl2-logo>

    <a class="mx-auto" (click)="onClick()">
      <span>{{ 'pageTitle.producers' | translate }}</span
      ><span>{{ 'pageTitle.portal' | translate }}</span>
    </a>
  </div>

  <div class="header-menu">
    <prp-header-menu></prp-header-menu>
  </div>
</div>
